import bgImage from 'assets/images/borderPassEasyBg.svg';

export const stylesFolderTypologyChoice = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  border: 1,
  borderRadius: 1,
  borderColor: 'grey.300',
  background: `url(${bgImage}) no-repeat top right`,
  p:3,
 'img':{
   height:'96px',
   mb:4,
 }
};
export const stylesFolderTypologyChoiceText = {
  color:'grey.500',
  'strong':{
    color:'grey.700',
    fontWeight:'fontWeightMedium'
  }
};

export const stylesFolderTypologyChoiceButton = {
  width: '100%',
  mt:4,
  '&:hover': {
    backgroundColor: '#044561 !important'
  }
};
